export const usageHitory = {
    fields: [        
        {
            key: 'orderNo',
            label: '주문번호',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'            
        },
        {
            key: 'orderDate',
            label: '접수일시',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'
        },
        {
            key: 'calcState',
            label: '승인상태',
            sortable: false,            
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'            
        },        
        {
            key: 'deptName',
            label: '부서명',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'            
        },
        {
            key: 'empName',
            label: '고객명',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'            
        },
        {
            key: 'customerPhoneNo',
            label: '전화번호',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'
        },
        {
            key: 'startAddr',
            label: '출발지',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'
        },
        {
            key: 'viaCount',
            label: '경유지 수',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'
        },
        {
            key: 'endAddr',
            label: '도착지',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'
        },            
        {
            key: 'payType',
            label: '결제방식',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'
        },
        {
            key: 'driverName',
            label: '기사명',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'
        },
        {
            key: 'sign',
            label: '서명',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'
        },
        {
            key: 'distance',
            label: '거리',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'
        },
        {
            key: 'completeDate',
            label: '완료일시',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'
        },
        {
            key: 'payAmount',
            label: '청구요금',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'
        },
        {
            key: 'cardVat',
            label: 'VAT',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 100px;'
        },       
        {
            key: 'totalAmount',
            label: '최종청구(VAT  포함)',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 300px;'
        } 
        ,       
        {
            key: 'totalAmount1',
            label: '최종청구(VAT  포함)',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 300px;'
        }    
        ,       
        {
            key: 'totalAmount2',
            label: '최종청구(VAT  포함)',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 300px;'
        }    
        ,       
        {
            key: 'totalAmount3',
            label: '최종청구(VAT  포함)',
            sortable: false,
            thClass: 'text-center',
            thStyle: ' max-width: 300px;'
        }                         
    ]
}

export const managedEmp = {
    fields: [        
        {
            key: 'name',
            label: '이름',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'deptName',
            label: '부서',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'positionName',
            label: '직급',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'stateName',
            label: '상태',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'webId',
            label: '로그인아이디',
            sortable: false,
            // Variant applies to the whole column, including the header and footer
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'phoneNo',
            label: '전화번호',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'limitOption.useLimitAmount',
            label: '이용한도금액',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'limitOption.useLimitCnt',
            label: '이용한도횟수',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'regDate',
            label: '등록일',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        }
        
        // ,
        // {
        //     key: 'modDate',
        //     label: '수정일',
        //     sortable: false,
        //     thClass: 'text-center',
        //     tdClass: 'small'
        // }
    ]
}

export const department = {
    fields: [               
        {
            key: 'deptName',
            label: '부서명',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'limitOption.overLimitPermitYN',
            label: '한도초과시 접수여부',
            sortable: false,
            // Variant applies to the whole column, including the header and footer
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'limitOption.useLimitCnt',
            label: '한도횟수',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'limitOption.useLimitAmount',
            label: '한도금액',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'                       
        },
        {
            key: 'regDate',
            label: '등록일',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'modDate',
            label: '수정일',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'regEmployees',
            label: '직원등록',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small',
            class: 'text-center'

        }
    ]
}

export const employees = {
    fields: [               
        {
            key: 'name',
            label: '이름',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'positionName',
            label: '직책',
            sortable: false,
            // Variant applies to the whole column, including the header and footer
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'phoneNo',
            label: '전화번호',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'carDesc',
            label: '차량정보',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'limitOption.overLimitPermitYN',
            label: '한도초과시 접수여부',
            sortable: false,
            // Variant applies to the whole column, including the header and footer
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'limitOption.useLimitCnt',
            label: '한도횟수',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'limitOption.useLimitAmount',
            label: '한도금액',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        }
    ]
}

export const drivers = {
    fields: [               
        {
            key: 'name',
            label: '이름',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'positionName',
            label: '직책',
            sortable: false,
            // Variant applies to the whole column, including the header and footer
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'phoneNo',
            label: '전화번호',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'duplicatePhoneNo',
            label: '전화번호 중복',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'carDesc',
            label: '차량정보',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'limitOption.overLimitPermitYN',
            label: '한도초과시 접수여부',
            sortable: false,
            // Variant applies to the whole column, including the header and footer
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'limitOption.useLimitCnt',
            label: '한도횟수',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'limitOption.useLimitAmount',
            label: '한도금액',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        }
    ]
}
export const logiOrder = {
    fields: [
        {
            key: 'logiOrderNo',
            label: '로지 접수번호',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'state',
            label: '상태',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'customerName',
            label: '고객명',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'regDate',
            label: '접수일시',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'startAddr',
            label: '출발지',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'endDate',
            label: '도착지',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'driverCompany',
            label: '기사소속',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'driverName',
            label: '기사명',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'endDate',
            label: '완료시간',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'orderNo',
            label: '로켓오더번호',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'syncResult',
            label: '동기화결과',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'isExistDriver',
            label: '기사정보 존재여부',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        }
    ]
}

export const order = {
    fields: [
        {
            key: 'reqDate',
            label: '접수시간',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'reqUserName',
            label: '주문자(어드바이저)',
            sortable: false,
            // Variant applies to the whole column, including the header and footer
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'reqUserPhoneNo',
            label: '주문자 연락처',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'startPhoneNo',
            label: '보내는 분 연락처',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'startAddr',
            label: '보내는분 주소',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'receiverType',
            label: '받는분 구분',
            sortable: false,
            // Variant applies to the whole column, including the header and footer
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'receiverName',
            label: '받는분 성함',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'receiverPhoneNo',
            label: '받는분 연락처',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'receiverAddr',
            label: '받는분 주소',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'reservDate',
            label: '예약시간',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'carNo',
            label: '차량번호',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'option',
            label: '빠른배차/왕복',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'etc',
            label: '특이사항',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'orderNo',
            label: '등록된 오더번호',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        }
    ]
}

export const searchOrder = {
    fields: [
        {
            key: 'reqDate',
            label: '접수시간',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'reqUserName',
            label: '주문자(어드바이저)',
            sortable: false,
            // Variant applies to the whole column, including the header and footer
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'reqUserPhoneNo',
            label: '주문자 연락처',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'startPhoneNo',
            label: '보내는 분 연락처',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'startAddr',
            label: '보내는분 주소',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'receiverType',
            label: '받는분 구분',
            sortable: false,
            // Variant applies to the whole column, including the header and footer
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'receiverName',
            label: '받는분 성함',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'receiverPhoneNo',
            label: '받는분 연락처',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'receiverAddr',
            label: '받는분 주소',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'reservDate',
            label: '예약시간',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'carNo',
            label: '차량번호',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'fastOrder',
            label: '빠른배차',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'etc',
            label: '특이사항',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'regDate',
            label: '등록일',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'orderNo',
            label: '등록된 오더번호',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        }
    ]
}

export const modifiedHistory = {
    fields: [
        {
            key: 'regDate',
            label: '수정시간',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'stateName',
            label: '수정상태',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'modDate',
            label: '수정일',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'orderNo',
            label: '로켓접수번호',
            sortable: false,
            thClass: 'text-center',
            thClass: 'small'
        },
        // {
        //     key: 'vendorNo',
        //     label: '연동 유입 경로',
        //     sortable: false,
        //     thClass: 'text-center',
        //     thClass: 'small'
        // },
        {
            key: 'transNo',
            label: '지카 오더 ID',
            sortable: false,
            thClass: 'text-center',
            thClass: 'small'
        },
        {
            key: 'reqName',
            label: '주문자(어드바이저)',
            sortable: false,
            // Variant applies to the whole column, including the header and footer
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'reqPhoneNo',
            label: '주문자 연락처',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'isCancel',
            label: '취소여부',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'senderPhoneNo',
            label: '보내는 분 연락처',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'senderAddr',
            label: '보내는분 주소',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'recipientPhoneNo',
            label: '받는분 연락처',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'recipientAddr',
            label: '받는분 주소',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'isReservation',
            label: '예약여부',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'reservationDate',
            label: '예약시간',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'carNo',
            label: '차량번호',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'isQuick',
            label: '빠른배차',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'isPickUp',
            label: '픽업',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'isDelivery',
            label: '딜리버리',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'isReciprocating',
            label: '왕복',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'memo',
            label: 'memo',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        },
        {
            key: 'managerName',
            label: '처리자',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'
        },
        {
            key: 'btn_complete',
            label: '수정완료',
            sortable: false ,
            thClass: 'text-center',
            tdClass: 'small'           
        }
    ]
}


// WEBPACK FOOTER //
// ./src/data/table.js